import React from "react";
import styled from "styled-components";

export default styled.button`
    height: 53px;
    color: white;
    background: #5562C0;
    padding: 15px 20px;
    font-family: 'Effra', sans-serif;
    border: 0;
    font-size: 20px;
    font-weight: 700;
    float: left;
`;